import { CloudOff, RefreshCw, X } from 'lucide-react'
import { useAuthStore } from '@/stores/authStore'

/**
 * 클라우드 동기화 실패 배너 (states#4)
 * - authStore.lastSyncError가 설정되고 로그인 상태일 때만 표시
 * - '다시 동기화' → authStore.retrySync (수동 재동기화 경로)
 * - X → lastSyncError 해제
 * - OfflineBanner의 고정 바 + safe-area 상단 패딩 패턴을 미러링
 * - 자체 스토어 구독으로 완전히 자급자족 (조건 미충족 시 null 렌더)
 */
export function SyncErrorBanner() {
  const user = useAuthStore((s) => s.user)
  const lastSyncError = useAuthStore((s) => s.lastSyncError)
  const syncStatus = useAuthStore((s) => s.syncStatus)
  const retrySync = useAuthStore((s) => s.retrySync)
  const clearSyncError = useAuthStore((s) => s.clearSyncError)

  if (!user || !lastSyncError) return null

  const isRetrying = syncStatus === 'syncing'

  return (
    <div
      role="alert"
      className="fixed top-0 left-0 right-0 z-50 flex items-center gap-2 px-3 py-2 bg-warning-500 text-white text-sm font-medium"
      // iPhone 노치/Dynamic Island 영역 아래로 내용이 깔리지 않도록 safe-area 상단 패딩 적용 (갤럭시는 0px fallback)
      style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 0.5rem)' }}
    >
      <CloudOff className="w-4 h-4 shrink-0" />
      <span className="flex-1 min-w-0 truncate">클라우드 동기화에 실패했습니다</span>

      <button
        type="button"
        onClick={() => retrySync()}
        disabled={isRetrying}
        className="flex items-center justify-center gap-1.5 min-h-[44px] px-3 -my-1.5 rounded-lg font-semibold whitespace-nowrap bg-white/20 hover:bg-white/30 active:bg-white/40 transition-colors disabled:opacity-60"
      >
        <RefreshCw className={`w-4 h-4 ${isRetrying ? 'animate-spin' : ''}`} />
        다시 동기화
      </button>

      <button
        type="button"
        onClick={clearSyncError}
        aria-label="알림 닫기"
        className="flex items-center justify-center min-w-[44px] min-h-[44px] -my-1.5 -mr-1 rounded-lg hover:bg-white/20 active:bg-white/30 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  )
}
